export default __webpack_public_path__ + "locales/pl/InfoPanel.json?hash=b47a1fb562d86a05e1b139b996f4dfb1";